import { render, staticRenderFns } from "./SettingDoctorSay.vue?vue&type=template&id=cbc9f6bc&scoped=true"
import script from "./SettingDoctorSay.vue?vue&type=script&lang=js"
export * from "./SettingDoctorSay.vue?vue&type=script&lang=js"
import style0 from "./SettingDoctorSay.vue?vue&type=style&index=0&id=cbc9f6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc9f6bc",
  null
  
)

export default component.exports